import { createSlice } from "@reduxjs/toolkit";

type ClientRating = {
    id: string | number;
    ratingIndex: number;
};

const initialState: ClientRating[] = [];

const clientRatingsSlice = createSlice({
    name: "clientRatings",
    initialState,
    reducers: {
        setClientRating(state, action) {
            const { id } = action.payload;
            const exists = state.some((client) => client.id === id);

            if (!exists) {
                return [...state, action.payload];
            }

            return state.map((client) => (client.id === id ? action.payload : client));
        },
        clearClientRatings() {
            return initialState;
        },
    },
});

export const { setClientRating, clearClientRatings } = clientRatingsSlice.actions;

export default clientRatingsSlice.reducer;
export const clientRatingsSliceReducer = clientRatingsSlice.reducer;
